import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { Tag } from '@sopranodesign/pulse-components';

const ActiveStatus = () => {
  return (
    <Tag background_colour="positive" colour="positive">
      Active
    </Tag>
  );
};

const ExpiringStatus = () => {
  return (
    <Tag background_colour="warning" colour="warning">
      Expiring
    </Tag>
  );
};

const ExpiredStatus = () => {
  return (
    <Tag background_colour="danger" colour="danger">
      Expired
    </Tag>
  );
};

const statuses = {
  active: ActiveStatus,
  expiring: ExpiringStatus,
  expired: ExpiredStatus
};

const LicenseStatus = ({ status }) => {
  const Component = useMemo(() => statuses[status], [status]);

  return <Component />;
};

LicenseStatus.propTypes = {
  status: PropTypes.oneOf(Object.keys(statuses)).isRequired
};

export default LicenseStatus;
